import { ShieldCheck, PersonStanding, Layers, Armchair } from "lucide-react";
import { Reveal } from "./Reveal";

const BENEFITS = [
    {
        icon: ShieldCheck,
        h: "Soulagement immédiat",
        t: "La découpe en U suspend le coccyx : la pression disparaît dès les premiers instants assis.",
    },
    {
        icon: PersonStanding,
        h: "Posture redressée",
        t: "Le bassin bascule naturellement en position neutre et le dos s’aligne sans effort.",
    },
    {
        icon: Layers,
        h: "Mousse haute densité",
        t: "Mémoire de forme 80 kg/m³ : un soutien ferme qui ne s’affaisse pas dans le temps.",
    },
    {
        icon: Armchair,
        h: "Bureau, voiture, maison",
        t: "Se pose sur n’importe quel siège grâce à sa base antidérapante Grip-Lock™.",
    },
];

export default function Benefits() {
    return (
        <section id="benefices" className="py-20 lg:py-32 bg-sand/40">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
                <Reveal className="max-w-2xl">
                    <p className="text-xs uppercase font-mono tracking-[0.25em] text-sage-mid">Bénéfices</p>
                    <h2 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-ink leading-[1.1]">
                        Trois promesses, <span className="italic text-sage">zéro compromis.</span>
                    </h2>
                </Reveal>
                <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
                    {BENEFITS.map((b, i) => (
                        <Reveal key={i} delay={i * 0.1} className="h-full">
                            <div
                                data-testid={`benefit-card-${i}`}
                                className="h-full rounded-3xl bg-white border border-sage/15 p-6 sm:p-8 transition-all duration-300 hover:bg-sage hover:border-sage hover:shadow-xl hover:shadow-sage/25 group"
                            >
                                <span className="w-12 h-12 rounded-2xl bg-sage-soft text-sage grid place-items-center transition-colors duration-300 group-hover:bg-cream/15 group-hover:text-cream">
                                    <b.icon size={22} strokeWidth={1.8} />
                                </span>
                                <h3 className="mt-6 font-serif text-xl lg:text-2xl text-ink group-hover:text-cream transition-colors duration-300">
                                    {b.h}
                                </h3>
                                <p className="mt-3 text-sm leading-relaxed text-[#4A5550] group-hover:text-cream/75 transition-colors duration-300">
                                    {b.t}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
